import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ForbiddenViewComponent } from './forbidden/forbidden.component';
import { LoginViewComponent } from './login/login.component';
import { AccountInformationComponent } from './main/account/account.component';
import { HomeViewComponent } from './main/home/home.component';
import {
  ADMINISTRATION_ROUTES,
  KHUYANA_ROUTES,
  REPORT_ROUTES,
} from './main/main-routing.module';
import { MainViewComponent } from './main/main.component';
import { NotFoundViewComponent } from './main/not-found/not-found.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
      { path: '', redirectTo: 'turno', pathMatch: 'full' },
      { path: 'medical-center-web', redirectTo: 'turno', pathMatch: 'full' },
      { path: 'salir', component: LoginViewComponent },
      { path: 'ingresar', component: LoginViewComponent },
      { path: '403', component: ForbiddenViewComponent },
      {
        path: '',
        component: MainViewComponent,
        children: [
          { path: 'agenda', component: HomeViewComponent },
          { path: 'cuenta', component: AccountInformationComponent },
          { path: '401', component: NotFoundViewComponent },
          { path: '404', component: NotFoundViewComponent },
          ...ADMINISTRATION_ROUTES,
          ...KHUYANA_ROUTES,
          ...REPORT_ROUTES,
        ],
      },
      { path: '**', redirectTo: '/404' },
    ]),
  ],
  exports: [RouterModule],
})
export class KhuyanaRoutingModule {}
